// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"826":"user-rights-roles","893":"login-home-welcome"}[chunkId] || chunkId) + "." + {"826":"a7c016b6","893":"d744be30","968":"438ebcc5"}[chunkId] + ".js";
};